<template>
  <div class="ioRecord">
    <!-- <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick"></AreaTree>
    </div> -->
    <div class="right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
        
            <el-select
              filterable
              v-model="search.parkingId"
              placeholder="请选择道路"
            >
              <el-option
                v-for="item in parkingList"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form-group">
           
            <el-date-picker
            placeholder="开始时间"
              clearable
              value-format="yyyy-MM"
              v-model="search.beginTime"
              type="month"
            ></el-date-picker>
          </div>
          <div class="form-group">
          
            <el-date-picker
            placeholder="结束时间"
              clearable
              value-format="yyyy-MM"
              v-model="search.endTime"
              type="month"
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :disabled="loading">
              <i v-if="loading" class="el-icon-loading"></i>
              {{ loading ? "查询中..." : "查询" }}
            </button>
            </span>
            <span class="download_btn">
              <button
                @click="downloadData"
                type="button"
                class="btn btn-primary"
                :disabled="exportLoading"
              >
                <i v-if="exportLoading" class="el-icon-loading"></i>
                {{ exportLoading ? "导出中..." : "导出" }}
            </button>
            </span>
          </div>
          <!-- <span class="switchGroup">
            <el-select v-model="switchValue" placeholder="请选择展示类型">
                <el-option value="list" label="列表">
                  <span class="switch">
                    <img src="@/assets/images/temp/liebiao.png" width="16px" />
                    <span class="switch-info">列表</span>
                  </span>
                </el-option>
                <el-option value="chart" label="图表">
                  <span class="switch">
                    <img src="@/assets/images/temp/tubiao.png" width="16px" />
                    <span class="switch-info">图表</span>
                  </span>
                </el-option>
              </el-select>
            </span> -->
        </form>
      </div>
      <div>
        <template>
          <!-- <div v-show="showChart" id="myChart" style="width:1000px;height:450px;"></div> -->
          <div
            v-show="showList"
            class="list-right"
            v-loading="loading"
            element-loading-text="数据加载中..."
          >
            <el-table
              ref="table"
              border
              :data="tableListData"
              height="100%"
              width="100%"
              :header-cell-style="tableHeaderStyle"
              :cell-style="tableCellStyle"
            >
              <el-table-column
                show-overflow-tooltip
                label="统计时间"
                prop="date"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="本月总实收"
                prop="real_money"
              ></el-table-column>
              <!-- 临停缴费分组 -->
              <el-table-column label="临停缴费">
                <el-table-column
                  show-overflow-tooltip
                  label="应收"
                  prop="temp_payable"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="实收"
                  prop="temp_received"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="微信"
                  prop="temp_wechat"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="支付宝"
                  prop="temp_alipay"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="现金"
                  prop="temp_cash"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="余额"
                  prop="temp_balance"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="未缴费"
                  prop="unpay"
                ></el-table-column>
              </el-table-column>
              <!-- 追缴欠费分组 -->
              <el-table-column label="追缴欠费">
                <el-table-column
                  show-overflow-tooltip
                  label="总额"
                  prop="arrears"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="微信"
                  prop="arrears_wechat"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="支付宝"
                  prop="arrears_alipay"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="现金"
                  prop="arrears_cash"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="余额"
                  prop="arrears_balance"
                ></el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="ETC"
                  prop="etc"
                ></el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </div>
      <Page v-show="showList" v-on:pagination="receivePaginationData"></Page>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  getParkingMonthReportList,
  getParkingMonthList,
  fetchParkigList,
} from "@/api/url";
import AreaTree from "../../commons/areaTree";
import Page from "../../commons/page";
import dayjs from "dayjs";
export default {
  data() {
    return {
      exportLoading: false,
      loading: false,
      styleObj: {
        "text-align": "center",
      },
      // body 单元格列分组斑马纹，与表头一致
      cellGroupIndex: {
        date: 0,
        real_money: 1,
        temp_payable: 2, temp_received: 2, temp_wechat: 2, temp_alipay: 2, temp_cash: 2, temp_balance: 2, unpay: 2,
        arrears: 3, arrears_wechat: 3, arrears_alipay: 3, arrears_cash: 3, arrears_balance: 3, etc: 3,
      },
      parkingList: [],
      tableListData: [],
      tableListDataTitle: [],
      switchValue: "list",
      showList: true,
      showChart: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        beginTime: dayjs().subtract(1, "month").format("YYYY-MM"),
        endTime: dayjs().format("YYYY-MM"),
        parkingId: "",
      },
      tableListData: [],
      // myChart: {
      //   title: {
      //     text: "",
      //   },
      //   tooltip: {
      //     trigger: "axis",
      //   },
      //   legend: {
      //     data: ["收入总额", "未缴费", "追缴欠费(总额)"],
      //   },
      //   grid: {
      //     left: "3%",
      //     right: "4%",
      //     bottom: "3%",
      //     containLabel: true,
      //   },
      //   toolbox: {
      //     // feature: {
      //     // 	saveAsImage: {}
      //     // }
      //   },
      //   xAxis: [
      //     {
      //       type: "category",
      //       axisLabel: {
      //         interval: 0,
      //         rotate: 40,
      //         color: "#333333",
      //       },
      //       name: "日期",
      //       data: [],
      //     },
      //   ],
      //   yAxis: {
      //     type: "value",
      //   },
      //   series: [
      //     {
      //       name: "收入总额",
      //       type: "line",
      //       data: [],
      //     },
      //     {
      //       name: "未缴费",
      //       type: "line",
      //       data: [],
      //     },
      //     {
      //       name: "追缴欠费(总额)",
      //       type: "line",
      //       data: [],
      //     },
      //   ],
      // },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    tableCellStyle({ column }) {
      const idx = this.cellGroupIndex[column.property] ?? -1;
      const bg = idx >= 0 && idx % 2 === 1 ? "#ECF5FF" : "#FFFFFF";
      return { "text-align": "center", "background-color": bg + " !important" };
    },
    tableHeaderStyle({ rowIndex, column }) {
      const base = { "text-align": "center" };
      const prop = column.property;
      const label = column.label;

      // 大列分组序号：统计时间=0, 本月总实收=1, 临停缴费=2, 追缴欠费=3
      const groupIndex = this.cellGroupIndex;
      // 一级表头也能被 label 识别
      const labelGroup = { "临停缴费": 2, "追缴欠费": 3 };
      const idx =
        rowIndex === 0 && labelGroup[label] != null
          ? labelGroup[label]
          : groupIndex[prop] ?? -1;

      const bg = idx >= 0 && idx % 2 === 1 ? "#ECF5FF" : "#FFFFFF";
      return { ...base, "background-color": bg + " !important" };
    },
    withExportLoading(task) {
      if (this.exportLoading) return;
      this.exportLoading = true;
      let released = false;
      const release = () => {
        if (released) return;
        released = true;
        this.exportLoading = false;
      };
      const timer = setTimeout(release, 1500);
      try {
        const request = task();
        if (request && typeof request.finally === "function") {
          return request.finally(() => {
            clearTimeout(timer);
            release();
          });
        }
        return request;
      } catch (error) {
        clearTimeout(timer);
        release();
        throw error;
      }
    },
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.search.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择道路！",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    // handleTreeClick: function (node, data) {
    //   this.search.beginTime = "";
    //   this.search.endTime = "";
    //   if (node.type == "parking") {
    //     this.treeData.parkingId = node.id;
    //     if (this.showList) {
    //       this.search.pageNumber = 1;
    //       this.tableList(this.search.pageNumber);
    //     }
    //     if (this.showChart) {
    //       this.echarts();
    //     }
    //   } else {
    //     this.treeData.parkingId = "";
    //     this.tableListData = [];
    //     var pageObj = {
    //       curIndex: 1,
    //       rowsCount: 0,
    //     };
    //     this.getPage(pageObj);
    //     //  this.$message({
    //     // 	message: '请选择车场！',
    //     // 	type: 'warning'
    //     // 	});
    //   }
    // },
    tableList: function (curPage) {
      var _this = this;
      this.loading = true;
      this.$get(getParkingMonthReportList(), {
        page: curPage,
        limit: this.search.pageSize,
        parkingId: this.search.parkingId,
        beginTime: this.search.beginTime,
        endTime: this.search.endTime,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        const fmt = (n) => (Number(n) || 0).toFixed(2);
        _this.tableListData = data.data.rows.map((row) => {
          const wechat = Number(row.wechat) || 0;
          const alipay = Number(row.alipay) || 0;
          const cash = Number(row.cash) || 0;
          const balance = Number(row.balance) || 0;
          const aw = Number(row.arrears_wechat) || 0;
          const aa = Number(row.arrears_alipay) || 0;
          const ac = Number(row.arrears_cash) || 0;
          const ab = Number(row.arrears_balance) || 0;
          const unpay = Number(row.unpay) || 0;
          const received = (wechat - aw) + (alipay - aa) + (cash - ac) + (balance - ab);
          const payable = received + unpay;
          return {
            ...row,
            temp_wechat: fmt(wechat - aw),
            temp_alipay: fmt(alipay - aa),
            temp_cash: fmt(cash - ac),
            temp_balance: fmt(balance - ab),
            temp_received: fmt(received),
            temp_payable: fmt(payable),
            real_money: fmt(row.real_money),
            arrears: fmt(row.arrears),
            unpay: fmt(unpay),
            etc: fmt(row.etc),
            arrears_wechat: fmt(aw),
            arrears_alipay: fmt(aa),
            arrears_cash: fmt(ac),
            arrears_balance: fmt(ab),
          };
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
          _this.syncHeaderScrollbar();
        });
      }).finally(() => {
          this.loading = false;
      });
    },
    // 图表
    // echarts: function () {
    //   var _this = this;
    //   this.$get(getParkingMonthList(), {
    //     limit: this.search.pageSize,
    //     groupId: this.treeData.groupId,
    //     parkingId: this.treeData.parkingId,
    //     beginTime: this.search.beginTime,
    //     endTime: this.search.endTime,
    //     companyId: this.treeData.companyId,
    //   }).then((data) => {
    //     this.myChart.series[0].data = [];
    //     this.myChart.series[1].data = [];
    //     this.myChart.series[2].data = [];
    //     this.myChart.xAxis[0].data = [];
    //     if (data.status != 200) return;
    //     for (var i in data.data.rows) {
    //       this.myChart.series[0].data.push(data.data.rows[i].real_money);
    //       this.myChart.series[1].data.push(data.data.rows[i].unpay);
    //       this.myChart.series[2].data.push(data.data.rows[i].arrears);
    //       this.myChart.xAxis[0].data.push(data.data.rows[i].date);
    //     }
    //     _this.$nextTick(() => {
    //       _this.$refs.table.doLayout();
    //     });
    //     let myChart = this.$echarts.init(document.getElementById("myChart"));
    //     myChart.setOption(this.myChart);
    //   });
    // },
    searchList: function () {
      if (this.loading) return;
      var flTime = this.timeCompare(this.search.beginTime, this.search.endTime);
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (!Boolean(this.search.beginTime)) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (!Boolean(this.search.endTime)) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }

      var compareTime = this.timeCompare(
        dayjs(this.search.beginTime).add(12, "month").format("YYYY-MM"),
        this.search.endTime
      );

      if (!compareTime) {
        return this.$layer.msg("请选择十二个月以内的日期", { time: 1 });
      }

      if (this.showList) {
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      }
      if (this.showChart) {
        this.echarts();
      }
    },
    timeCompare: function (bDateVal, eDateVal) {
      // console.log(bDateVal,eDateVal);

      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }

      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
      this.tableList(this.search.pageNumber);
    },
    getParkingList() {
      return this.$get(fetchParkigList()).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          this.parkingList = data;
        }
      });
    },
    async initParking() {
      await this.getParkingList();
      this.search.parkingId = this.parkingList[0].parkingId;
      this.tableList(this.search.pageNumber);
    },
    // 横向滚动：表头与 body 双向同步，避免滑到最右列错位
    bindTableScrollSync() {
      const table = this.$refs.table?.$el;
      if (!table) return;

      const headerWrapper = table.querySelector('.el-table__header-wrapper');
      const bodyWrapper = table.querySelector('.el-table__body-wrapper');
      if (!headerWrapper || !bodyWrapper) return;

      let syncing = false;

      const syncScroll = (source) => {
        if (syncing) return;
        syncing = true;

        if (source === 'body') {
          headerWrapper.scrollLeft = bodyWrapper.scrollLeft;
        } else {
          bodyWrapper.scrollLeft = headerWrapper.scrollLeft;
        }

        requestAnimationFrame(() => { syncing = false; });
      };

      bodyWrapper.addEventListener('scroll', () => syncScroll('body'), { passive: true });
      headerWrapper.addEventListener('scroll', () => syncScroll('header'), { passive: true });
    },
    // 修正：body 出现纵向滚动条时，表头需同步补偿滚动条宽度，避免横向滚到最右列错位
    syncHeaderScrollbar() {
      const table = this.$refs.table;
      if (!table) return;
      const bodyWrap = table.$el.querySelector(".el-table__body-wrapper");
      const headerWrap = table.$el.querySelector(".el-table__header-wrapper");
      if (!bodyWrap || !headerWrap) return;
      // 判断 body 是否出现纵向滚动条
      const hasVScroll = bodyWrap.scrollHeight > bodyWrap.clientHeight + 1;
      const barW = hasVScroll ? (bodyWrap.offsetWidth - bodyWrap.clientWidth) : 0;
      headerWrap.style.paddingRight = barW > 0 ? barW + "px" : "";
    },
    downloadData() {
      return this.withExportLoading(() =>
        this.$downloadFileRequest(
        "/api/parking/parkingOrders/monthlyStatementExport",
        {
          parkingId: this.search.parkingId,
          beginTime: this.search.beginTime,
          endTime: this.search.endTime,
        },
        "道路月报"
      )
      );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  components: {
    Page,
    AreaTree,
  },

  mounted: function () {
    // this.echarts();
    this.initParking();
    // 修复横向滚动时表头与 body 错位
    this.$nextTick(() => {
      this.bindTableScrollSync();
    });
    window.addEventListener("resize", this.syncHeaderScrollbar);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.syncHeaderScrollbar);
  },
  watch: {
    // switchValue: function (newVal, oldVal) {
    //   if (newVal === "chart") {
    //     this.showChart = true;
    //     this.showList = false;
    //     if (this.treeData.parkingId) {
    //       this.echarts();
    //     }
    //   } else {
    //     this.showChart = false;
    //     this.showList = true;
    //     if (this.treeData.parkingId) {
    //       this.tableList(this.curIndex);
    //     }
    //   }
    // },
  },
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: white !important;
  border-bottom: none !important;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px 10px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex !important;
  display: flex !important;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}
.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}

/* ========== 修复多级表头横向滚动错位 ========== */

/* 1. 强制表格使用 fixed 布局算法，确保列宽稳定 */
.ioRecord .el-table {
  table-layout: fixed !important;
}

/* 2. 确保 header 和 body 的容器宽度完全一致，仅 body 显示滚动条 */
.ioRecord .el-table__header-wrapper,
.ioRecord .el-table__body-wrapper {
  width: 100% !important;
}
.ioRecord .el-table__body-wrapper {
  overflow-x: auto !important;
}

/* 3. 修复多级表头的内部对齐 */
.ioRecord .el-table__header thead th {
  position: relative;
}

/* 4. 消除 border 导致的 1px 累积偏差 */
.ioRecord .el-table--border .el-table__cell {
  box-sizing: border-box !important;
}
</style>